import { getLocalStorageData, setLocalStorageData } from "../helpers/api_helper";
import CryptoJS from 'crypto-js';

const SESSION_KEY = process.env.REACT_APP_SESSION_KEY;
//const TIMEOUT = 20 * 60 * 1000; // 20 minutes
const TIMEOUT = process.env.REACT_APP_LOGINTIME * 60 * 1000;

let dispatchFn = null;
let showModalFn = null
let timeoutId = null;
let userLogoutFlag = true; // Flag to track user logout status

export function setDispatch(dispatchFunction) {
  dispatchFn = dispatchFunction;
}

export function setUserLogoutFlag() {
  return userLogoutFlag; // Return the updated status
}

export function setModalCallback(callback) {
  showModalFn = callback; // Save the modal open handler
}

export function updateSessionTime() {
  const appData = getLocalStorageData("authUser");
  if (appData && hasSessionExpired()) {
    if (typeof showModalFn === "function") {
     showModalFn(true); // ✅ Tell React to show the modal
   }
    // clearSession();
  }
  setLocalStorageData(SESSION_KEY, Date.now())
  //localStorage.setItem(SESSION_KEY, Date.now());
  //resetAutoLogoutTimer();
}

export function hasSessionExpired(timeout = 20 * 60 * 1000) {
  const lastActive = parseInt(getLocalStorageData(SESSION_KEY), 10);
  if (!lastActive) return false;
  return lastActive && Date.now() - lastActive > TIMEOUT;
}

export function clearSession() {
  //localStorage.removeItem(SESSION_KEY);
  localStorage.clear();
  if (dispatchFn) dispatchFn();
  window.location.href = "/login";
}

// function resetAutoLogoutTimer() {
//   const appData = getLocalStorageData("authUser");
//   if (timeoutId) clearTimeout(timeoutId);
//   if (appData) {    
//     timeoutId = setTimeout(() => {
//       clearSession();
//     }, TIMEOUT);
//   }
// }

// // Start monitoring user activity
// export function startInactivityTimer() {
//   // Initial call
//   updateSessionTime();

//   const activityEvents = ["keydown", "mousedown"];

//   activityEvents.forEach(event =>
//     window.addEventListener(event, updateSessionTime)
//   );
// }


const DEBUG_FLAG_KEY = process.env.REACT_APP_DEBUG_KEY;
const SECRET_KEY = process.env.REACT_APP_DEBUG_SECRETE;

// Save encrypted
export const setDebugFlag = (flag) => {
  // ensure it's stored as string "0"/"1" or "true"/"false"
  //const stringValue = JSON.stringify(flag);
  //const encrypted = CryptoJS.AES.encrypt(stringValue, SECRET_KEY).toString();
  localStorage.setItem(DEBUG_FLAG_KEY, flag);
};

// Read encrypted
export const getDebugFlag = () => {
  const value = localStorage.getItem(DEBUG_FLAG_KEY);
  if (!value) return null;

  try {
    //const decrypted = CryptoJS.AES.decrypt(value, SECRET_KEY).toString(CryptoJS.enc.Utf8);
    //return JSON.parse(decrypted);
    return value;
  } catch (e) {
    console.error("Failed to decrypt debug flag:", e);
    return null;
  }
};

// Clear storage
export const clearDebugFlag = () => {
  localStorage.removeItem(DEBUG_FLAG_KEY);
};
 
